import { useState } from 'react';

import classNames from 'classnames';
import axios from 'axios';
import { InputNew, Button, TextareaNew, SelectNew } from '../../../ui';
import OfferModal from './OfferModal';

const OfferForm = props => {
  const { className, country } = props;

  const [values, setValues] = useState({
    name: '',
    phone: '',
    companyName: '',
    email: '',
    message: '',
    offer: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isThanksOpen, setIsThanksOpen] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!values.name) newErrors.name = 'Սխալ կամ կիսատ լրացված դաշտ';
    if (!values.email) newErrors.email = 'Սխալ կամ կիսատ լրացված դաշտ';
    if (!values.companyName) newErrors.companyName = 'Սխալ կամ կիսատ լրացված դաշտ';
    else if (!emailValidation(values.email)) newErrors.email = 'Սխալ կամ կիսատ լրացված դաշտ';
    if (!values.phone) newErrors.phone = 'Սխալ կամ կիսատ լրացված դաշտ';

    return newErrors;
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setLoading(false);
    setErrors({ ...errors, [name]: '' });

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const formData = new FormData();

    for (let key in values) {
      formData.append(key, key === 'phone' ? `+374 ${values[key]}` : values[key]);
    }

    formData.append('country', country);
    formData.append('service', 'Gift Season Offer Request');

    axios.post('https://mailer.weprodigi.com/api/v1/offers', formData).then(response => {
      setLoading(false);
      setValues({ name: '', phone: '', companyName: '', email: '', message: '', offer: '' });
      setIsThanksOpen(true);
    });
  };

  const emailValidation = email => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };

  return (
    <div className="relative">
      <form onSubmit={handleSubmit} className={classNames('flex flex-col gap-[32px]', className)}>
        <div className="flex lg:flex-row flex-col gap-[32px]">
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Անուն Ազգանուն"
              isRequired={true}
              name="name"
              placeholder="Անուն Ազգանուն"
              value={values.name}
              error={errors.name}
              onChange={handleChange}
            />
          </div>
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Հեռախոսահամար"
              isRequired={true}
              name="phone"
              placeholder="00 000 000"
              value={values.phone}
              error={errors.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex lg:flex-row flex-col gap-[32px]">
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Կազմակերպություն"
              isRequired={true}
              name="companyName"
              placeholder="Կազմակերպություն"
              value={values.companyName}
              error={errors.companyName}
              onChange={handleChange}
            />
          </div>
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Էլ. հասցե"
              name="email"
              type="email"
              placeholder="Էլ, հասցե"
              isRequired={true}
              value={values.email}
              error={errors.email}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex md:flex-row flex-col gap-[32px] w-full items-end">
          <div className="flex flex-col gap-[16px] w-full lg:w-1/2">
            <p className="md:text-[18px] text-[16px] font-[500] leading-[20px] text-white">Հաղորդագրություն</p>
            <TextareaNew name="message" placeholder="Հաղորդագրություն" value={values.message} onChange={handleChange} />
          </div>
          <div className="flex flex-col md:gap-[16px] gap-[32px] w-full lg:w-1/2 relative">
            <SelectNew name="offer" placeholder="Ընտրել առաջարկը" value={values.offer} onChange={handleChange} />
            <div className="flex items-center justify-center">
              <Button variant="transparentOffer" mode="light" className="w-full hover:md:w-[290px]">
                {loading && (
                  <svg viewBox="0 0 200 200" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                        <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                        <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                      </linearGradient>
                      <linearGradient id="pl-grad2" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                        <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                      </linearGradient>
                    </defs>
                    <circle
                      className="pl__ring"
                      cx="100"
                      cy="100"
                      r="82"
                      fill="none"
                      stroke="url(#pl-grad1)"
                      strokeWidth="36"
                      strokeDasharray="0 257 1 257"
                      strokeDashoffset="0.01"
                      strokeLinecap="round"
                      transform="rotate(-90,100,100)"
                    />
                    <line
                      className="pl__ball"
                      stroke="url(#pl-grad2)"
                      x1="100"
                      y1="18"
                      x2="100.01"
                      y2="182"
                      strokeWidth="36"
                      strokeDasharray="1 165"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
                Ստանալ առաջարկ
              </Button>
            </div>
          </div>
        </div>
      </form>
      {isThanksOpen && <OfferModal />}
    </div>
  );
};

export default OfferForm;
